<template>
  <div class="q-pa-md q-gutter-sm">
    <q-btn
      label="Filtros"
      no-caps
      icon="filter_alt"
      color="primary"
      @click="abrirModal = true"
    />

    <q-dialog
      v-model="abrirModal"
      :persistent="persistent"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 700px">
        <div class="bg-brand-1 text-white">
          <q-card-section>
            <div class="text-h6">Selecione os Filtros</div>
          </q-card-section>

          <q-card-section class="q-pt-none">
            Depois de selecionado, click em 'ok' para carregar os dados.
          </q-card-section>
        </div>

        <div v-if="!dataDisable" class="row text-brand-5 text-weight-bold">
          <span style="width: 48%" class="col-2 q-ml-sm q-mt-sm"
            >Data Inicial</span
          >
          <span style="width: 44%" class="col-2 q-ml-sm q-mt-sm"
            >Data Final</span
          >
        </div>

        <div v-if="!dataDisable" class="row col col-3 q-px-sm">
          <q-input
            style="width: 49%"
            class="col input"
            dense
            outlined
            placeholder="DD/MM/AAAA"
            v-model="filtros.data1.from"
            mask="##/##/####"
            :disable="dataDisable"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    :options="optionsFn"
                    mask="DD/MM/YYYY"
                    v-model="filtros.data1"
                    range
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>

          <q-input
            class="col q-ml-sm input"
            style="width: 49%"
            dense
            outlined
            placeholder="DD/MM/AAAA"
            v-model="filtros.data1.to"
            mask="##/##/####"
            :disable="dataDisable"
          >
          </q-input>
        </div>

        <div
          v-if="tipoSelecao == 'multiple' && !unidadeDisable"
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div v-if="tipoSelecao == 'multiple'" class="col">
            <div class="texto-titulo-input">Unidade Destino</div>
            <q-select
              dense
              outlined
              v-model="filtros.unidadeSelecionada"
              multiple
              map-options
              label="Selecione as unidades"
              label-color="grey-6"
              :bg-color="unidadeDisable ? 'brand-7' : ''"
              :disable="unidadeDisable"
              :options="optionsUnidade"
            />
          </div>
          <div v-if="regiao" class="col">
            <div class="texto-titulo-input">Região1</div>
            <q-input v-model="filtros.regiao" dense outlined />
          </div>
        </div>

        <div
          v-if="tipoSelecao == 'single' && !unidadeDisable"
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div v-if="tipoSelecao == 'single'" class="col">
            <div class="texto-titulo-input">Unidade Destino</div>
            <q-select
              dense
              outlined
              option-label="label"
              option-value="value"
              v-model="filtrosSingle"
              :options="optionsUnidade"
              label="Unidade Destino"
              label-color="grey-6"
            />
          </div>
          <div class="col">
            <div class="texto-titulo-input">Numero Reserva</div>
            <q-input v-model="filtrosSingle.reserva" dense outlined />
          </div>

          <div v-if="regiao" class="col">
            <div class="texto-titulo-input">Região2</div>
            <q-input v-model="filtrosSingle.regiao" dense outlined />
          </div>
          <div v-if="cliente" class="col">
            <SelecaoClientes @enviarCliente="receberCliente" />
          </div>
          <!-- <div v-if="data" class="col">
            <div class="texto-titulo-input">Data</div>
            <q-input
              class="input"
              dense
              outlined
              placeholder="DD/MM/AAAA"
              v-model="filtros.data1.to"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      :options="optionsFn"
                      mask="DD/MM/YYYY"
                      v-model="filtros.data1.to"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div> -->
        </div>
        <div
          v-if="tipoSelecao == 'single' && !unidadeDisable"
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div class="col">
            <div class="texto-titulo-input">Numero Requisição</div>
            <q-input v-model="filtrosSingle.VouncherId" dense outlined />
          </div>
          <div v-if="!integracao" class="col">
            <div class="texto-titulo-input">Numero Picking</div>
            <q-input v-model="filtrosSingle.numero" dense outlined />
          </div>
          <div v-if="integracao" class="col">
            <div class="texto-titulo-input">Operação</div>

            <q-select
              v-model="filtrosSingle.operacao"
              options-value="value"
              label="Selecione o Status"
              label-color="grey-6"
              :options="operacaoOptions"
              dense
              emit-value
              map-options
              outlined
            />
          </div>
        </div>

        <div
          v-if="tipoSelecao == 'single' && !unidadeDisable"
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div v-if="integracao" class="col">
            <div class="texto-titulo-input">Com erro</div>

            <q-select
              v-model="filtrosSingle.erro"
              options-value="value"
              label="Selecione o Status"
              label-color="grey-6"
              :options="erroOptions"
              dense
              emit-value
              map-options
              outlined
            />
          </div>

          <div v-if="integracao" class="col">
            <div class="texto-titulo-input">Solicitante</div>

            <SelecaoSolicitante @emitirFuncionario="receberFuncionario" />
          </div>
        </div>

        <div
          v-if="tipoSelecao == 'single' && !unidadeDisable"
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div v-if="integracao" class="col-md-6">
            <div class="texto-titulo-input">Produto</div>
            <q-input
              dense
              outlined
              v-model="filtrosSingle.produto"
              maxlength="10"
              class="texto-titulo-input"
            />
          </div>
        </div>

        <div
          v-if="tipoSelecao == 'singleOrigemDestino' && !unidadeDisable"
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div class="col">
            <div class="text-brand-5 text-weight-bold">Origem</div>
            <q-select
              dense
              outlined
              v-model="filtrosSingleOrigemDestino.origem"
              option-label="label"
              option-value="value"
              :bg-color="unidadeDisable ? 'brand-7' : ''"
              :disable="unidadeDisable"
              :options="optionsUnidade"
            />
          </div>
          <div class="col">
            <div class="text-brand-5 text-weight-bold">Destino</div>
            <q-select
              dense
              outlined
              v-model="filtrosSingleOrigemDestino.destino"
              option-label="label"
              option-value="value"
              :bg-color="unidadeDisable ? 'brand-7' : ''"
              :disable="unidadeDisable"
              :options="optionsUnidade"
            />
          </div>
        </div>
        <slot name="conteudo"></slot>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn
            label="Filtrar"
            :loading="loading"
            no-caps
            icon="filter_alt"
            dense
            color="primary"
            @click="emitirFiltros"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
import SelecaoClientes from "../../backOffice/components/SelecaoClientes.vue";
export default {
  components: { SelecaoClientes, SelecaoSolicitante },
  props: [
    "loadingValue",
    "unidadeDisable",
    "tipoSelecao",
    "dataDisable",
    "regiao",
    "cliente",
    "data",
    "semUnidade",
    "integracao",
  ],
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();
    const unidade = ref("");
    const filtros = ref({
      data1: { from: "", to: "" },
      regiao: "",
      unidadeSelecionada: [
        {
          id: store.state.org.unidadeData.id,
          label: store.state.org.unidadeData.nome,
        },
      ],
    });
    const filtrosSingle = ref({
      id: store.state.org.unidadeData.id,
      label: store.state.org.unidadeData.nome,
      regiao: "",
      cliente: "",
      numero: "",
      VouncherId: "",
      reserva: "",
      operacao: "",
      erro: "",
      solicitanteMatricula: "",
      solicitantePesquisa: "",
      produto: "",
    });
    const filtrosSingleOrigemDestino = ref({
      origem: {
        id: store.state.org.unidadeData.id,
        label: store.state.org.unidadeData.nome,
      },
      destino: {
        id: "",
        label: "",
      },
    });
    const optionsUnidade = ref([]);
    const quasar = useQuasar();
    const loading = ref(false);
    const abrirModal = ref(
      route.params.id != "" &&
        route.params.id != undefined &&
        route.params.id != "carregado"
        ? false
        : true
    );
    const persistent = ref(false);
    const id = route.params.id;

    const emitirFiltros = async () => {
      loading.value = true;
      if (
        props.semUnidade != "vazio" &&
        filtros.value.unidadeSelecionada.length == 0 &&
        !props.unidadeDisable
      ) {
        quasar.notify({
          message: "Selecione ao menos uma unidade Unidades",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (filtros.value.data1.from == "") {
        let dataInicial = new Date();
        let dataFinal = new Date();
        dataFinal.setDate(dataFinal.getDate());
        dataInicial.setDate(dataInicial.getDate() - 16);
        filtros.value.data1.from = dataInicial.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        filtros.value.data1.to = dataFinal.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }

      if (filtros.value.data1 != "") {
        filtros.value.data1.from = filtros.value.data1.from
          .split("/")
          .reverse()
          .join("-");

        filtros.value.data1.to = filtros.value.data1.to
          .split("/")
          .reverse()
          .join("-");
      }

      if (props.tipoSelecao == "multiple") {
        emit("unidade", filtros.value);
      }

      if (props.tipoSelecao == "single") {
        emit("unidade", filtros.value.data1, filtrosSingle.value);
      }

      if (props.tipoSelecao == "singleOrigemDestino") {
        emit("unidade", filtros.value.data1, filtrosSingleOrigemDestino.value);
      }

      if (props.tipoSelecao == undefined) {
        emit("unidade");
      }

      filtros.value.data1 = { from: "", to: "" };
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        let array = response.listaUnidades;
        array.forEach((unidade) => {
          optionsUnidade.value.push({
            label: unidade.nome,
            id: unidade.id,
          });
        });
        optionsUnidade.value.unshift({ label: "Todas", id: null });
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => props.loadingValue,
      () => {
        loading.value = props.loadingValue;
        if (loading.value == false) {
          setTimeout(() => {
            abrirModal.value = false;
            persistent.value = false;
          }, 1000);
        }
      }
    );

    watch(
      () => filtros.value.unidadeSelecionada,
      () => {
        filtros.value.unidadeSelecionada.forEach((unidade) => {
          if (
            unidade.label == "Todas" &&
            filtros.value.unidadeSelecionada.length > 1
          ) {
            filtros.value.unidadeSelecionada = [];
            filtros.value.unidadeSelecionada = [{ label: "Todas", id: "" }];
          }
        });
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        filtros.value.unidadeSelecionada[0].id = store.state.org.unidadeData.id;
        filtros.value.unidadeSelecionada[0].label =
          store.state.org.unidadeData.nome;
        filtrosSingle.value.label = store.state.org.unidadeData.nome;
        filtrosSingle.value.id = store.state.org.unidadeData.id;
        filtrosSingleOrigemDestino.value = {
          origem: {
            id: store.state.org.unidadeData.id,
            label: store.state.org.unidadeData.nome,
          },
        };
      }
    );

    const verificarPersistencia = async () => {
      if (id) {
        persistent.value = false;
      }
    };

    onMounted(verificarPersistencia);
    onMounted(listarUnidades);

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
        filtros.value.unidadeSelecionada[0].id = unidade.value.id;
        filtros.value.unidadeSelecionada[0].label = unidade.value.nome;
        filtrosSingle.value.label = unidade.value.nome;
        filtrosSingle.value.id = unidade.value.id;
      }
    };

    const receberCliente = (value) => {
      filtrosSingle.value.cliente = value;
    };

    onMounted(getUnidade);

    const receberFuncionario = (value) => {
      filtrosSingle.value.solicitanteMatricula = value;
      filtrosSingle.value.solicitantePesquisa = value?.nome;
    };

    return {
      abrirModal,
      id,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      receberFuncionario,
      optionsFn(date) {
        var hoje = new Date();

        var ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());

        var dd = ontem.getDate();
        var mm = ontem.getMonth() + 1;
        var yyyy = ontem.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }

        var data_ok = yyyy + "/" + mm + "/" + dd;

        return date <= data_ok;
      },
      emitirFiltros,
      loading,
      persistent,
      verificarPersistencia,
      listarUnidades,
      optionsUnidade,
      receberCliente,
      filtrosSingle,
      filtrosSingleOrigemDestino,
      unidade,
      erroOptions: [
        { label: "Sim", value: "sim" },
        { label: "Não", value: "nao" },
      ],
      operacaoOptions: [
        { label: "Criação", value: "Criação" },
        { label: "Estorno", value: "Estorno" },
        { label: "Cancelamento", value: "Cancelamento" },
        { label: "Baixa", value: "baixa" },
      ],
    };
  },
};
</script>

<style scoped>
@media screen and (max-width: 900px) {
  .input {
    width: 47% !important;
  }
}
</style>
